import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaEnvelope } from "react-icons/fa";
import { FaLinkedinIn, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-100 text-gray-700 border-t">

      <div className="max-w-6xl mx-auto px-6 py-8">

        {/* Top Section */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">

          {/* Left Spacer (hidden on mobile) */}
          <div className="hidden md:block w-24"></div>

          {/* Menu */}
          <div className="flex flex-wrap justify-center gap-5 text-sm text-center">
            <Link to="/insurance" className="hover:text-black">Insurance</Link>
            <Link to="/loans" className="hover:text-black">Loans</Link>
            <Link to="/blogs" className="hover:text-black">Blog</Link>
            <Link to="/about" className="hover:text-black">About</Link>
            <Link to="/contact" className="hover:text-black">Contact</Link>
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-4 text-gray-600 text-lg">
<div className="flex gap-4">
  {/* LinkedIn */}
  <a
    href="https://www.linkedin.com/company/abhifs/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaLinkedinIn className="cursor-pointer hover:text-black" />
  </a>

  {/* YouTube */}
  <a
    href="https://www.youtube.com/@abhimandagiri"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaYoutube className="cursor-pointer hover:text-black" />
  </a>

  {/* Email */}
  <a href="mailto:info@abhifs.com">
    <FaEnvelope className="cursor-pointer hover:text-black" />
  </a>
</div>
          </div>

        </div>

        {/* Divider */}
        <div className="border-t border-gray-300 my-6"></div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row items-center justify-between text-sm gap-4 text-center md:text-left">

          {/* Left */}
          <p className="text-gray-600">
            © 2026 Abhishek M Financial Services Pvt Ltd. Designed & Developed By Zenvi Technologies
          </p>

          {/* Right */}
          <div className="flex gap-6">
           <div className="flex gap-4">
  <Link
    to="/terms-and-conditions"
    className="hover:text-black cursor-pointer"
  >
    Terms & Conditions
  </Link>

  <Link
    to="/privacy-policy"
    className="hover:text-black cursor-pointer"
  >
    Privacy Policy
  </Link>
</div>
          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;